import 'magnific-popup'
import AOS from 'aos'
import $ from 'jquery'

// options at: https://dimsemenov.com/plugins/magnific-popup/

class Modal {
  constructor() {
    if (
      document.location.hash !== ''
      && $(document.location.hash).length
      && $(document.location.hash).hasClass('block--type--modal')
    ) {
      $.magnificPopup.open({
        items: {
          src: document.location.hash,
          type: 'inline'
        },
        overflowY: 'scroll'
      })
    }


    $('a').each(function () {
      const href = $(this).attr('href')
      const link = $(this)
      if (
        typeof href !== 'undefined'
        && href.startsWith('#')
        && href.length > 1
        && $(href).hasClass('block--type--modal')
      ) {
        $(this).magnificPopup({
          items: {
            src: href,
            type: 'inline'
          },
          //type: 'inline',
          overflowY: 'scroll',
          callbacks: {
            open: function() {
              $(href).find('.aos-animate').removeClass('aos-animate').delay(1000).promise().done(function() {
                AOS.init({
                  duration: 1000,
                })
              })
            }
          }
        })
      }

      if (
        typeof href !== 'undefined'
        && href.startsWith('http')
        && !href.startsWith(window.location.origin)
        && !href.includes('.pdf')
        && !link.hasClass('external-link-popup-disabled')
        && $('#popleave').length
      ) {
        $(this).off('click').on('click', function (e) {
          e.preventDefault()
          e.stopImmediatePropagation()

          let suffix = ''
          const linkAttr = link.attr('link') || ''
          const hasPatient =
            linkAttr.includes('patient') ||
            /tryngolzahcp\.com/i.test(href)
          const hasIonis =
            linkAttr.includes('ionis') ||
            href.includes('ionis')

          if (hasPatient && hasIonis) {
            suffix = '-patient-ionis'
          } else if (hasPatient) {
            suffix = '-patient'
          } else if (hasIonis) {
            suffix = '-ionis'
          }
          const popupID = '#popleave' + suffix

          $.magnificPopup.open({
            items: {
              src: popupID,
              type: 'inline'
            },
            callbacks: {
              open: function() {
                $(`${popupID} .ok`).off('click').on('click', function (e) {
                  e.preventDefault()
                  e.stopPropagation()
                  window.open(href, '_blank')
                  $.magnificPopup.close()
                  return false
                })

                $(`${popupID} .cancel`).off('click').on('click', function (e) {
                  e.preventDefault()
                  e.stopPropagation()
                  $.magnificPopup.close()
                  return false
                })
              }
            }
          })
          return false
        })
      }


      /*if (
        typeof href !== 'undefined'
        && href.startsWith('#representative')
        && $('#representative').length
      ) {
        $(this).magnificPopup({
          items: {
            src: '#representative',
            type: 'inline'
          },
          callbacks: {
            open: function() {
              $('#representative .close').on('click', function (e) {
                e.preventDefault
                e.stopPropagation
                $.magnificPopup.close()
                return false
              })
            }
          }
        })
      }

      if (
        typeof href !== 'undefined'
        && href.startsWith('#subscribe')
        && $('#subscribe').length
      ) {
        $(this).magnificPopup({
          items: {
            src: '#subscribe',
            type: 'inline'
          },
          callbacks: {
            open: function() {
              $('#subscribe .close').on('click', function (e) {
                e.preventDefault
                e.stopPropagation
                $.magnificPopup.close()
                return false
              })
            }
          }
        })
      }*/
    })
  }
}

export default Modal
